<template>
  <PageLayout class="pets-page">
    <div class="pets-page__title-block">
      <div class="pets-page__title">
        <PageTitle>Перевірте дані та перейдіть до оформленя</PageTitle>
        <Breadcrumbs
          class="pets-page__breadcrumbs"
          :breadcrumbs="getBreadcrumbs"
        />
      </div>
      <div class="pets-page__back">
        <SmartLink
          v-if="isFromHistory"
          class="pets-page__back-link"
          @click="$router.back()"
        >
          <OpenDownIcon color="#0A77FF" class="pets-page__back-link__icon" />
          Повернутися
        </SmartLink>
        <SmartLink
          v-else
          class="pets-page__back-link"
          @click="$router.push({ name: 'petsPolicyDetails' })"
        >
          <OpenDownIcon color="#0A77FF" class="pets-page__back-link__icon" />
          Повернутися до попереднього кроку
        </SmartLink>
      </div>
    </div>
    <PetsFinalization />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { PetsFinalization } from '@/features/pets-finalization';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { OpenDownIcon } from '@/shared/ui/icons';
import { PageLayout } from '@/shared/ui/layouts';
import { SmartLink } from '@/shared/ui/link';
import { PageTitle } from '@/shared/ui/page-title';

export default {
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageTitle, Breadcrumbs, OpenDownIcon, SmartLink, PageLayout, PetsFinalization },
  computed: {
    isFromHistory() {
      return this.$route.query.from === 'history';
    },
    getBreadcrumbs() {
      return [
        {
          title: 'Панель управління',
          url: '#',
        },
        {
          title: 'Страхування тварин',
          url: '#',
        },
        {
          title: 'Пропозиції від СК',
          url: '#',
        },
        {
          title: 'Оформлення страхової',
          url: '#',
        },
        {
          title: 'Перевірка даних',
          url: '#',
        },
      ];
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.pets-page {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  &__title-block {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 24px;
  }

  &__title {
    margin-bottom: 16px;

    @media (max-width: 500px) {
      margin-bottom: 50px;
    }
  }

  &__breadcrumbs {
    margin-bottom: 0;
  }

  &__back-link {
    display: flex;
    align-items: center;
    font-family: 'Geist', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #0A77FF;
    margin-right: 4px;
    cursor: pointer !important;

    &__icon {
      transform: rotate(90deg);
    }
  }
}

::v-deep .breadcrumbs {
  margin-bottom: 0 !important;
}
</style>